// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/login-bg-img.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-wrapper {
  display: flex;
  align-items: stretch;
}
.login-wrapper.admin .container{
  max-width: 431px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.login-form-wrapper {
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.login-form-wrapper.admin{
  position: relative;
  width: 100%;
  padding: 0;
}

.logo-wrapper.admin{
  position: absolute;
  top:0;
  left: 0;
  right:0;
  margin: auto;
  padding: 20px;
  display: flex;
  justify-content: center;
  background-color: #fff;
}

.login-bg-img {
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.login-form-wrapper .container {
  max-width: 431px;
  width: 100%;
}

.input-icon {
  position: relative;
}

.login-form-wrapper .input-icon svg {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
  color: #ccc;
}

.login-form-wrapper input.form-control {
  border: none;
  border-bottom: 2px solid #00863F;
  border-radius: 0;
}

.login-form-wrapper input.form-control:focus {
  outline: none;
  border-color: #00863F;
}

.checkbox-link {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.checkbox-link a {
  margin-left: 5px;
}

.login-form-wrapper button[type='submit'] {
  margin-top: 20px;
}

.login-form-wrapper .form-label {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
}

.login-form-wrapper l.login-btn.btn {
  box-shadow: 0px 4px 26px rgba(0, 0, 0, 0.25);
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  padding: 14px 10px 18px 10px;
}

.social-media-wrapper {
  text-align: center;
  margin-top: 40px;
}

.login-form-wrapper .form-check {
  display: flex;
  align-items: center;
}

.login-form-wrapper .form-check .form-check-label {
  margin-left: 5px;
}

.login-form-wrapper input[type=checkbox] {
  width: 15px;
  height: 15px;
  border: 1px solid #000000;
  border-radius: 0;
  margin-top: 0;
}

.background-image .img-wrapper {
  padding-top: 40px;
  padding-left: 30px;
}

.login-form-wrapper .input-group-text {
  border: none;
  border-bottom: 2px solid #00863F;
  border-radius: 0;
  background-color: transparent;
  padding: 5px;
}

.social-media-wrapper img{
  margin:10px;
}

img.pwd-icon {
  width: 16px;
}
.login-bg-img .img-wrapper{
  padding: 10px;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
}`, "",{"version":3,"sources":["webpack://./src/screens/login/login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,KAAK;EACL,OAAO;EACP,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,yDAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,4EAA4E;AAC9E","sourcesContent":[".login-wrapper {\n  display: flex;\n  align-items: stretch;\n}\n.login-wrapper.admin .container{\n  max-width: 431px;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.login-form-wrapper {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.login-form-wrapper.admin{\n  position: relative;\n  width: 100%;\n  padding: 0;\n}\n\n.logo-wrapper.admin{\n  position: absolute;\n  top:0;\n  left: 0;\n  right:0;\n  margin: auto;\n  padding: 20px;\n  display: flex;\n  justify-content: center;\n  background-color: #fff;\n}\n\n.login-bg-img {\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100vh;\n  background-image: url('../../assets/images/login-bg-img.png');\n}\n\n.login-form-wrapper .container {\n  max-width: 431px;\n  width: 100%;\n}\n\n.input-icon {\n  position: relative;\n}\n\n.login-form-wrapper .input-icon svg {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 10px;\n  color: #ccc;\n}\n\n.login-form-wrapper input.form-control {\n  border: none;\n  border-bottom: 2px solid #00863F;\n  border-radius: 0;\n}\n\n.login-form-wrapper input.form-control:focus {\n  outline: none;\n  border-color: #00863F;\n}\n\n.checkbox-link {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.checkbox-link a {\n  margin-left: 5px;\n}\n\n.login-form-wrapper button[type='submit'] {\n  margin-top: 20px;\n}\n\n.login-form-wrapper .form-label {\n  font-family: 'Montserrat';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 16px;\n}\n\n.login-form-wrapper l.login-btn.btn {\n  box-shadow: 0px 4px 26px rgba(0, 0, 0, 0.25);\n  font-weight: 600;\n  font-size: 17px;\n  line-height: 21px;\n  padding: 14px 10px 18px 10px;\n}\n\n.social-media-wrapper {\n  text-align: center;\n  margin-top: 40px;\n}\n\n.login-form-wrapper .form-check {\n  display: flex;\n  align-items: center;\n}\n\n.login-form-wrapper .form-check .form-check-label {\n  margin-left: 5px;\n}\n\n.login-form-wrapper input[type=checkbox] {\n  width: 15px;\n  height: 15px;\n  border: 1px solid #000000;\n  border-radius: 0;\n  margin-top: 0;\n}\n\n.background-image .img-wrapper {\n  padding-top: 40px;\n  padding-left: 30px;\n}\n\n.login-form-wrapper .input-group-text {\n  border: none;\n  border-bottom: 2px solid #00863F;\n  border-radius: 0;\n  background-color: transparent;\n  padding: 5px;\n}\n\n.social-media-wrapper img{\n  margin:10px;\n}\n\nimg.pwd-icon {\n  width: 16px;\n}\n.login-bg-img .img-wrapper{\n  padding: 10px;\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
